module.exports = __webpack_public_path__ + "img/project_thumbnail.ad78bfb.png";